import { __extends } from 'tslib';
import web2clientSounds from '@lst/web2clientapi/sound';
import classNames from 'classnames';
import * as React from 'react';
import Button from '../Button/Button.js';
import styles from './ButtonPromo.module.scss.js';

var ButtonPromo = (function (_super) {
    __extends(ButtonPromo, _super);
    function ButtonPromo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (event) {
            event.stopPropagation();
            web2clientSounds.playButtonSound();
            if (_this.props.onClick) {
                _this.props.onClick(event);
            }
        };
        return _this;
    }
    ButtonPromo.prototype.render = function () {
        var _a;
        var classNameContainer = classNames(styles.container, this.props.className, (_a = {},
            _a[styles.center] = this.props.isCenter,
            _a[styles.disabled] = this.props.isDisabled,
            _a));
        return (React.createElement("div", { className: classNameContainer }, !!this.props.isFlat ? (React.createElement(Button, { isFlat: true, isLarger: true, type: "orange", isDisabled: this.props.isDisabled, onClick: this.onClick }, this.props.children)) : (React.createElement("button", { className: styles.button, onClick: this.onClick },
            React.createElement("div", { className: styles.inner }, this.props.children)))));
    };
    return ButtonPromo;
}(React.PureComponent));

export { ButtonPromo as default };
//# sourceMappingURL=ButtonPromo.js.map
